

export * from './lib/core-data.module';
export { DataService as SpaceOneCoreDataService, TypeKey } from './lib/spaceOne/data.service';
export { DataService as GeoDsCoreDataService } from './lib/geoDs/data.service';
export { PersistenceService as GeoDsPersistenceService, IPersistable } from './lib/geoDs/persistence.service';
export { PersistenceService } from './lib/persistence.service';
export * from './lib/helpers';
export * from './lib/models/query.model'
